import * as z from "zod";

export const loginSchema = z.object({
  username: z
    .string()
    .min(1, "Username or email is required")
    .transform((val) => val.trim()),
  password: z.string().min(1, "Password is required"),
});

export type LoginFormData = z.infer<typeof loginSchema>;